export default "__VITE_ASSET__C3A518jU__"